import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Utils } from '@messaia/cdk';
import { PhoneNumber } from '../../models/phone-number';
import { OrderService } from '../../services/order.service';

@Component({
    selector: 'app-additional-numbers-dialog',
    templateUrl: 'additional-numbers-dialog.component.html'
})
export class AdditionalNumbersDialogComponent {

    /**
     * numbers: number
     */
    public numbers: number;

    /**
     * Constructor
     * @param dialogRef 
     * @param data 
     */
    constructor(
        protected service: OrderService,
        public dialogRef: MatDialogRef<AdditionalNumbersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: number
    ) { }

    /**
     * Save data
     */
    public save(): void {
        this.service.addPhoneNumbers(this.data, Utils.range(1, this.numbers, 1).map(_ => new PhoneNumber()))
            .subscribe(x => this.dialogRef.close());
    }

    /**
     * Closes the dialog
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}